import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BreadcrumbContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "8px 0",
  marginBottom: "1rem",
});

export const StyledBreadcrumbs = styled(Breadcrumbs)({
  "& .MuiBreadcrumbs-separator": {
    color: "#94a3b8",
    margin: "0 4px",
  },
});

export const BreadcrumbLink = styled(Link)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: "#64748b",
  fontSize: "0.875rem",
  fontWeight: 500,
  textDecoration: "none",
  cursor: "pointer",
  transition: "color 0.2s",
  "&:hover": {
    color: "#3b82f6",
    textDecoration: "none",
  },
});

export const BreadcrumbText = styled(Typography)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: "#1e293b",
  fontSize: "0.875rem",
  fontWeight: 500,
});

export const IconWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "inherit",
});
